module.exports = __webpack_public_path__ + "img/kailash_peacejam.c52bbd2f.jpg";